export const nav = {
home: 'Home',
about: 'About',
leadership: 'Leadership',
vision: 'Vision & Mission',
products: 'Products',
business_model: 'Business Model',
operations: 'Operations',
structure: 'Structure',
compliance: 'Compliance',
contact: 'Contact',
privacy: 'Privacy Policy',
terms: 'Terms of Service',
cookies: 'Cookie Policy',
};
